import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'atoms/Asset/AssetWrapper';
import { ImageContainer } from './ImageBlock.styles';

interface ImageBlockProps {
  imageProps: AssetWrapperProps['imageProps'];
}

const ImageBlock = ({ imageProps }: ImageBlockProps): JSX.Element => (
  <ImageContainer
    columns={5}
    hideOn='md'
    justify='center'
    align='center'
  >
    <AssetWrapper
      imageProps={imageProps}
      maxWidth={600}
      cover
    />
  </ImageContainer>
);

export default ImageBlock;
